import React from 'react';

const GoBackIcon = () => {
    return (
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 1L1 7.5L7.5 14" stroke="#70CFD6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default GoBackIcon;